export default __webpack_public_path__ + "static/media/logo.719fff99.png";